import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useClient } from '../../client-api';
import { deleteAdvisoryNeedTask } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useDeleteAdvisoryNeedTask = (): UseMutationResult<void, AxiosError, number> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: async (id) => {
            await deleteAdvisoryNeedTask({ path: { id: id } });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.advisoryNeedTasks(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.events(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.notifications() });
            queryClient.invalidateQueries({ queryKey: queryKeys.notificationsForClient(client?.id) });
        },
    });
};
